import { CatalogEntityTypes, Dataset } from 'features/data-explorer/types'
import { User } from 'features/users'

export const STORAGE_CONTACT_ME_REQUEST = 'CONTACT_ME_REQUEST'

export enum HubspotFromSections {
  Builder = 'builder',
  DataExplorer = 'dataExplorer',
  DataObservatory = 'dataObservatory'
  // TODO: add more sections if needed
}

export enum QuotasRequestOptions {
  EndingTrial = 'ending_trial',
  ReachingQuotas = 'reaching_quotas',
  EditorUsers = 'editor_users',
  ViewerUsers = 'viewer_users',
  TotalMaps = 'total_maps',
  PublicMaps = 'public_maps',
  Apps = 'apps',
  Geocode = 'geocode',
  Workflows = 'workflows',
  Usage = 'usage',
  Lds = 'lds',
  SSOUpgrade = 'sso_upgrade',
  SSOEnable = 'sso_enable',
  GroupsUpgrade = 'groups_upgrade',
  GroupsEnable = 'groups_enable',
  BrandingUpgrade = 'branding_upgrade',
  BrandingEnable = 'branding_enable',
  ActivityDataUpgrade = 'activity_data_upgrade'
}

export enum QuotaUxTrigger {
  MoreInfo = 'more_info',
  BuilderMoreInfo = 'builder_more_info',
  WorkspaceMoreInfo = 'workspace_more_info',
  NewMap = 'new_map',
  DuplicateMap = 'duplicate_map',
  NewMapDe = 'new_map_DE',
  Developers = 'developers',
  Invite = 'invite',
  SwitchRole = 'switch_role',
  DataExplorer = 'data_explorer'
}

export interface RequestSubscriptionHubspotFormProps {
  dataset: Dataset
  datasetType: CatalogEntityTypes
}

export interface HubspotForm {
  firstname?: User['name']
  lastname?: string
  jobtitle?: string
  company?: string
  email: User['email']
  phone?: number
  carto_3_quotas_request: QuotasRequestOptions
}
